import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#1CC23A" tint={0.1}>
    {/* A grid of tables. */}
    <rect x="3" y="4" width="18" height="16" rx="2.5" />
    <path d="M12 4v16M3 12h18" />
  </ContentTile>
);
